import { db } from './config';
import {
  doc, getDoc, setDoc, getDocs,
  collection, onSnapshot,
} from 'firebase/firestore';

const COL = 'content';

export async function getSection(id) {
  const snap = await getDoc(doc(db, COL, id));
  return snap.exists() ? snap.data() : null;
}

export async function saveSection(id, data) {
  await setDoc(
    doc(db, COL, id),
    { ...data, _updatedAt: new Date().toISOString() },
    { merge: true }
  );
}

export async function getAllSections() {
  const snap = await getDocs(collection(db, COL));
  const out = {};
  snap.forEach(d => { out[d.id] = d.data(); });
  return out;
}

export function watchSection(id, cb) {
  return onSnapshot(doc(db, COL, id), snap => {
    if (snap.exists()) cb(snap.data());
  });
}
